import { environment } from "@environments/environment";

export const BASE_API_URL =  `${environment.baseApiUrl}api`;

export const BASE_NOTIFICATIONS_API_URL = `${BASE_API_URL}/notifications`;
export const HR_NOTIFICATION_ENDPOINT = `${BASE_NOTIFICATIONS_API_URL}/hr`;

export const BASE_MESSAGES_API_URL = `${BASE_API_URL}/messages`;

export const BASE_METRICS_API_URL = `${BASE_API_URL}/metrics`;
export const METRICS_START_CONVERSATION_ENDPOINT = `${BASE_METRICS_API_URL}/start-conversation`;
export const METRICS_QUESTION_ASKED_ENDPOINT = `${BASE_METRICS_API_URL}/question-asked`;
export const METRICS_QUESTION_ANSWERED_ENDPOINT = `${BASE_METRICS_API_URL}/question-answered`;
export const METRICS_QUESTION_FAILED_ENDPOINT = `${BASE_METRICS_API_URL}/question-failed`;
export const METRICS_QUESTION_RATED_ENDPOINT = `${BASE_METRICS_API_URL}/question-rated`;
export const METRICS_SENT_TO_HR_ENDPOINT = `${BASE_METRICS_API_URL}/sent-to-hr`;
export const METRICS_SENT_GREETINGS_ENDPOINT = `${BASE_METRICS_API_URL}/sent-greeting`;
export const METRICS_ANSWER_WAS_HELPFUL_ENDPOINT = `${BASE_METRICS_API_URL}/answer-was-helpful`;
export const METRICS_ANSWER_WAS_NOT_HELPFUL_ENDPOINT = `${BASE_METRICS_API_URL}/answer-was-not-helpful`;
export const METRICS_SENT_TO_USER_ENDPOINT = `${BASE_METRICS_API_URL}/email-sent-to-user`;
export const METRICS_NOT_SENT_TO_HR_ENDPOINT = `${BASE_METRICS_API_URL}/not-sent-to-hr`;
export const METRICS_NOT_SENT_TO_USER_ENDPOINT = `${BASE_METRICS_API_URL}/not-sent-to-user`;